import { render } from "./NavigationList.vue?vue&type=template&id=66951d3c&scoped=true"
import script from "./NavigationList.vue?vue&type=script&lang=js"
export * from "./NavigationList.vue?vue&type=script&lang=js"

import "./NavigationList.vue?vue&type=style&index=0&id=66951d3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66951d3c"

export default script